import NamedAnimatedModal from './NamedAnimatedModal'

export default NamedAnimatedModal
